export default "__VITE_ASSET__C8uzbnn$__"